export default __webpack_public_path__ + "static/media/user-upload2-image.e1e936ed.jpeg";